import { SessionAdapter, Storage } from '@mirai/data-sources';

import { EXPERIMENT_ID, VARIANT, VARIANT_STORAGE_KEY } from '../Core.constants';

const IS_JEST = !!process?.env?.JEST_WORKER_ID;

const variantStorage = new Storage({ adapter: SessionAdapter });

const { A, B } = VARIANT;

export const getVariant = ({ urlParams = {} } = {}) => {
  if (!EXPERIMENT_ID || (IS_JEST && !window.IS_PLAYWRIGHT)) return undefined;

  if (urlParams.variant === A || urlParams.variant === B) {
    variantStorage.set(VARIANT_STORAGE_KEY, urlParams.variant);
    return urlParams.variant;
  }

  const stored = variantStorage.get(VARIANT_STORAGE_KEY);
  if (stored === A || stored === B) return stored;

  const next = Math.random() < 0.5 ? A : B;
  variantStorage.set(VARIANT_STORAGE_KEY, next);
  return next;
};
